<template lang="pug">
div
  v-btn.ml-0.primary(@click='modal_open')
    | Export CSV
  liondesk-dialog(
    :dialog-title='"Export Sub-Accounts Report"',
    ok-button-text='Close',
    hide-cancel-button,
    @click:ok='modal_close',
    :width="'initial'",
    v-model="isModalVisible",
  )
    div.dialog-main-container(slot='body')
      template
        v-layout(align-center, justify-center, column, fill-height)
          v-icon.excel-icon(x-large, color='primary') file_present
          p 
            | Your report for
            span.date-range-title {{ dateRange }}
            | has been created.
          v-btn.ml-0.primary(@click='csvExport()')
            | Download
</template>

<script>
import LiondeskDialog from '@/Core/components/LiondeskDialog';
import Modal from '@/Core/mixins/modal';
import { TEAM_MEMBER } from '@/Reporting/config/constants';

export default {
  name: 'ExportReportModal',
  components: {
    LiondeskDialog,
  },
  mixins: [Modal],
  props: {
    dateRange: {
      type: String,
      default: '',
    },
    exportData: {
      type: Array,
      default: [],
    },
    headers: {
      type: Array,
      default: [],
    },
    includeComparedPercentage: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    mountContent() {
      const getHeadersWithPercentage = this.headers
        .filter(d => d.comparison)
        .reduce(
          (acc, val) => {
            return [...acc, val.text, val.comparison];
          },
          ['Name'],
        );

      if (!this.includeComparedPercentage) {
        const content = [
          this.headers.map(({ text }) => text).join(','),
          ...this.exportData.map(({ events }) => {
            let dataToExport = [];
            const keys = events.map(evt => Object.keys(evt)[0]);

            for (const key of keys) {
              const { name, count } = events.find(evt => Object.keys(evt)[0] === key)[key];
              const data = key === TEAM_MEMBER ? name : count;
              dataToExport = [...dataToExport, data];
            }
            return dataToExport.join(',');
          }),
        ]
          .join('\n')
          .replace(/(^\[)|(\]$)/gm, '');

        return `data:text/csv;charset=utf-8,${content}`;
      }

      const content = [
        getHeadersWithPercentage.join(','),
        ...this.exportData.map(({ events }) => {
          let dataToExport = [];
          const keys = events.map(evt => Object.keys(evt)[0]);

          for (const key of keys) {
            const event = events.find(evt => Object.keys(evt)[0] === key)[key];

            if (key === TEAM_MEMBER) {
              dataToExport = [...dataToExport, event.name];
              continue;
            }

            dataToExport = [...dataToExport, event.count, `${event.percentage_comparison}%`];
          }

          return dataToExport.join(',');
        }),
      ]
        .join('\n')
        .replace(/(^\[)|(\]$)/gm, '');

      return `data:text/csv;charset=utf-8,${content}`;
    },
    csvExport() {
      const content = this.mountContent();
      const data = encodeURI(content);

      const link = document.createElement('a');
      link.setAttribute('href', data);

      const docTitle = this.dateRange.replace(/,/g, '').split(' ').join('_');
      link.setAttribute('download', `${docTitle}.csv`);
      link.click();
    },
  },
};
</script>

<style lang="scss" scoped>
.excel-icon {
  margin-bottom: 20px;
}
.dialog-main-container {
  margin: 0 12px;
}
.date-range-title {
  margin: 0 6px;
  font-weight: 600;
}
</style>
